<script lang="ts" setup>
import { computed, Ref } from 'vue'
import HelpLabel from '@/components/HelpLabel.vue'
import i18n from '@/helper/Translations'

const props = defineProps<{
  labelFor?: string
  label?: string
  labelKey?: string
  externalLinkUrl?: string
  required?: boolean
  isDeleteDisabled?: boolean
  error?: Ref<string> | string
}>()

const labelText = computed(() => {
  if (props.labelKey) {
    return i18n.global.t(props.labelKey)
  }

  return props.label || ''
})
</script>

<template>
  <div :class="{ 'is--required': required }" class="form__element">
    <div v-if="labelText" class="label-parent">
      <label :for="labelFor">{{ labelText }}</label>

      <a v-if="externalLinkUrl" :href="externalLinkUrl" class="external-link" target="_blank">
        <i class="ic-external-link" />
        <span>{{ $t('global.external_link_label') }}</span>
      </a>

      <HelpLabel :translation-key="labelKey" />
    </div>

    <div class="form__input-wrapper">
      <slot />
    </div>

    <p v-if="error" :title="error" class="form__error">
      {{ error }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.label-parent {
  display: flex;
  margin-bottom: rem-calc(8);
  align-items: center;

  label {
    margin-bottom: 0;
  }

  .btn.is--raw {
    line-height: rem-calc(20);

    i {
      margin-right: 0;
    }
  }

  .external-link {
    margin-left: 5px;
    text-decoration: none;

    i {
      vertical-align: middle;
    }

    span {
      text-decoration: underline;
    }
  }
}
</style>
